import { createFileRoute } from '@tanstack/react-router'

import CariPetaniPage from '@/components/pages/backoffice/_klb-petani/_cari-petani/containers/CariPetaniPage'

export const Route = createFileRoute('/_backoffice/klb-petani/cari-petani/')({
  component: CariPetaniPage
})
